import { Box, Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';
import { EditableLabel } from '../common/EditableLabel';
import usePermission from '../common/permissions/usePermission';
import { TruncatedTextTooltip } from '../common/TruncatedTextTooltip';

const AgentInfo = ({
  icon,
  name,
  persona,
  onEditName,
  iconSize,
}: {
  icon: ReactNode;
  name: string;
  persona?: string;
  onEditName?: (name: string) => void;
  iconSize: string;
}) => {
  const [isAllowedRename] = usePermission(['edit:ai-agent']);
  return (
    <Stack direction="row" alignItems="center" gap={1} flex={1} minWidth={0}>
      <Box sx={{ flex: `0 0 ${iconSize}`, display: 'flex' }}>{icon}</Box>
      <Stack flex={1} minWidth={0}>
        {onEditName && isAllowedRename ? (
          <Box sx={{ position: 'relative', left: '-4px' }}>
            <EditableLabel
              onValueConfirm={onEditName}
              value={name}
              padding={'2px 4px'}
              height={24}
              maxCharLength={256}
              inputSx={{ fontSize: '14px', fontWeight: 400 }}
            />
          </Box>
        ) : (
          <TruncatedTextTooltip variant="body-medium" color={colors.grey[900]}>
            {name}
          </TruncatedTextTooltip>
        )}
        {persona && (
          <Typography variant="caption" color={colors.grey[700]}>
            {persona}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default AgentInfo;
